var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaminhao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.917 52.6666H131.667L151.417 79.3686V118.5H138.02C137.237 123.992 134.499 129.018 130.308 132.654C126.118 136.289 120.756 138.291 115.208 138.291C109.66 138.291 104.299 136.289 100.108 132.654C95.9177 129.018 93.1797 123.992 92.3971 118.5H59.0196C58.2369 123.992 55.4989 129.018 51.3084 132.654C47.1178 136.289 41.7562 138.291 36.2083 138.291C30.6604 138.291 25.2988 136.289 21.1083 132.654C16.9177 129.018 14.1797 123.992 13.3971 118.5H6.58331V39.5C6.58331 37.754 7.27691 36.0795 8.51153 34.8448C9.74614 33.6102 11.4206 32.9166 13.1666 32.9166H105.333C107.079 32.9166 108.754 33.6102 109.988 34.8448C111.223 36.0795 111.917 37.754 111.917 39.5V52.6666ZM111.917 65.8333V85.5833H138.25V83.707L125.031 65.8333H111.917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaminhao);
export default __webpack_public_path__ + "static/media/caminhao.45d98c2aa93d19dd5c811fbdf3172d16.svg";
export { ForwardRef as ReactComponent };